import { GTMClient } from '~/tracking/providers/GoogleTagManager';

export const useGoogleTagManager = () => {
    return { googleTagManager: GTMClient.build() };
};
